export type CopyViewport='web'|'mobile'|'base';
export const copyVariantKey=(key:string,viewport:Exclude<CopyViewport,'base'>)=>`viewport.${viewport}.${key}`;
export const isCopyVariant=(key:string)=>/^viewport\.(web|mobile)\./.test(key);
export const copyVariables=(text:string)=>[...new Set([...text.matchAll(/\{(\w+)\}/g)].map(match=>match[1]))].sort();
export type Copy=(key:string,values?:Record<string,string|number>)=>string;
// Store message identity through asynchronous work so resizing or a live copy
// update also changes an already-visible result, without repeating the request.
export function copyMessage(key:string,values:Record<string,string|number>={}){return '@copy:'+JSON.stringify({key,values});}
export function copyMessageParts(value:string):{key:string;values:Record<string,string|number>}|null{
 if(!value.startsWith('@copy:'))return null;
 try{const result=JSON.parse(value.slice(6));return typeof result.key==='string'&&result.values&&typeof result.values==='object'?result:null;}catch{return null;}
}

// Optional overrides stay in the existing persisted copy dictionary. Empty or
// invalid overrides fall back to operator copy, never a new packaged default.
export function copyVariantProblem(base:string,value:string){
 if(!value.trim())return '';
 if(value.length>3000)return 'copy.tooLong';
 if(JSON.stringify(copyVariables(base))!==JSON.stringify(copyVariables(value))||/[{}]/.test(value.replace(/\{\w+\}/g,'')))return 'copy.variablesInvalid';
 return '';
}
export function copyTemplate(copy:Record<string,string>,key:string,viewport:CopyViewport='base'){
 const base=copy[key]??(key.startsWith('api.')?copy['api.failed']:undefined)??key;
 const variant=viewport==='base'?undefined:copy[copyVariantKey(key,viewport)];
 return variant?.trim()&&!copyVariantProblem(base,variant)?variant:base;
}
export function formatCopy(template:string,values:Record<string,string|number>={}){
 return template.replace(/\{(\w+)\}/g,(match,name:string)=>values[name]===undefined?match:String(values[name]));
}
